/**
 * Created by Administrador on 07/05/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('profileUserService', profileUserService);

    profileUserService.$inject = ['$http', 'CONFIG', 'messageService'];

    function profileUserService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/users';
        var service = {
            updateProfile: updateProfile,
            getProfile: getProfile
        }

        return service;

        function updateProfile(user){
            return $http.put(urlBase + "/profile", user)
                .then(function(response){
                    messageService.registerUpdate('users');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('users')
                });
        }

        function getProfile(){
            return $http.get(urlBase+'/profile')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }
    }
})();
